exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".prepare{background:url(" + require("../assets/bg/prepare.jpg") + ") no-repeat;background-attachment:fixed;background-size:cover;position:relative}.prepare:after{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background:hsla(0,0%,100%,.5)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3103f86a","scoped":false,"hasInlineConfig":false}!./~/autoprefixer-loader!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/prepareContent.vue
// module id = 38
// module chunks = 0